import * as Website from '../../Config/Website.js';


const preinit = () => {

}

const init = () => {
  
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}